'use strict'

var isEnabled = function isEnabled() {
  return (
    (window.IntercomIncludeInDevelopment ||
      process.env.NODE_ENV === 'production') &&
    typeof Intercom === 'function' &&
    window.IntercomAppId
  )
}

exports.onInitialClientRender = function() {
  if (
    !isEnabled() &&
    (window.location.pathname == '/contact' ||
      window.location.pathname == '/contact/')
  ) {
    return
  }

  window.intercomSettings = {
    app_id: window.IntercomAppId,
    From_URL: window.location.href,
    hide_default_launcher:
      window.location.pathname == '/contact' ||
      window.location.pathname == '/contact/'
        ? true
        : false,
  }

  if (
    window.location.pathname !== '/contact' ||
    window.location.pathname == '/contact/'
  ) {
    window.Intercom('boot', {
      app_id: window.IntercomAppId,
    })
  }
}

exports.onRouteUpdate = function(_ref) {
  var location = _ref.location

  if (
    !isEnabled() &&
    (location.pathname == '/contact' || location.pathname == '/contact/')
  ) {
    return
  }
  window.intercomSettings = {
    app_id: window.IntercomAppId,
    From_URL: location.href,
    hide_default_launcher:
      location.pathname == '/contact' || location.pathname == '/contact/'
        ? true
        : false,
  }
  if (location.pathname !== '/contact' || location.pathname == '/contact/') {
    window.Intercom('update', window.intercomSettings)
  }
}
